import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import VolumeOffIcon from 'mdi-material-ui/VolumeOff';
import VolumeHighIcon from 'mdi-material-ui/VolumeHigh';

import { withMediaProps } from 'react-media-player';

class StandardPlayButton extends React.Component {
  shouldComponentUpdate({ media }) {
    return this.props.media.isMuted !== media.isMuted;
  }

  handleMuteUnmute = () => {
    this.props.media.muteUnmute();
  };

  render() {
    const { media } = this.props;
    return (
      <IconButton onClick={this.handleMuteUnmute}>
        {media.isMuted ? <VolumeOffIcon /> : <VolumeHighIcon />}
      </IconButton>
    );
  }
}

export default withMediaProps(StandardPlayButton);
